import { useCallback } from "react";
import AnalyticsService from "../utils/analytics";

export const useAnalytics = () => {
    const analytics = AnalyticsService.getInstance();

    const track = useCallback(
        (eventName: string, properties?: Record<string, any>) => {
            analytics.track(eventName, properties);
        },
        [analytics]
    );

    const page = useCallback(
        (pageName?: string, properties?: Record<string, any>) => {
            analytics.page(pageName, properties);
        },
        [analytics]
    );

    const identify = useCallback(
        (userId: string, traits?: Record<string, any>) => {
            analytics.identify(userId, traits);
        },
        [analytics]
    );

    const isInitialized = useCallback(() => {
        return analytics.isInitialized();
    }, [analytics]);

    return {
        track,
        page,
        identify,
        isInitialized,
    };
};
